import {
    generatePathReg as engineGeneratePathReg,
    htmlRenderItem as engineHtmlRenderItem,
    htmlRenderItems as engineHtmlRenderItems,
    type RenderItem,
} from "@circleofa/acim-engine"

const engineFootnoteLinkRegex = /<a data-footnote="([0-9]+)" href="">\1<\/a>/g
const engineCourseReferenceButtonRegex = /<button class="([^"]*)" data-link="([^"]+)">/g
const courseReferenceClass = "link underline course-reference-link"

export function connectFootnoteButtons(html: string) {
    return html.replace(engineFootnoteLinkRegex, (_, footnoteNumber: string) => {
        return `<a class="footnoteButton" onclick="openFootnote(${footnoteNumber}); return false;" href="">${footnoteNumber}</a>`
    })
}

export function connectCourseReferenceButtons(html: string, classList = courseReferenceClass) {
    return engineGeneratePathReg(html, classList).replace(
        engineCourseReferenceButtonRegex,
        (_, classes: string, path: string) =>
            `<button type="button" class="${classes}" data-link="${path}" onclick="createQuotedPiece(this.dataset.link); return false;">`,
    )
}

export function htmlRenderItems(items: RenderItem[]) {
    return connectFootnoteButtons(engineHtmlRenderItems(items))
}

export function htmlRenderItem(renderItem: RenderItem) {
    return connectFootnoteButtons(engineHtmlRenderItem(renderItem))
}
